import React from "react";
import { CheckCircle2 } from "lucide-react";

/**
 * steps: [{ key, label }]
 * current: string key
 */
export default function ProgressStepper({ steps, current }) {
  const idx = steps.findIndex((s) => s.key === current);
  return (
    <ol className="flex items-center gap-2 md:gap-4 mb-8" data-testid="progress-stepper">
      {steps.map((s, i) => {
        const done = i < idx;
        const active = i === idx;
        return (
          <li key={s.key} className="flex-1 flex items-center gap-2 min-w-0">
            <div
              className={
                "flex h-8 w-8 items-center justify-center rounded-full text-xs font-medium shrink-0 " +
                (done
                  ? "bg-primary text-primary-foreground"
                  : active
                  ? "bg-secondary text-secondary-foreground ring-2 ring-primary/40"
                  : "bg-muted text-muted-foreground")
              }
              data-testid={`step-${s.key}`}
            >
              {done ? <CheckCircle2 size={16} /> : i + 1}
            </div>
            <span className={"hidden md:inline text-sm truncate " + (active ? "font-medium" : "text-muted-foreground")}>
              {s.label}
            </span>
            {i < steps.length - 1 && (
              <span className={"flex-1 h-px " + (done ? "bg-primary/40" : "bg-border")} />
            )}
          </li>
        );
      })}
    </ol>
  );
}

export const RESPONDENT_STEPS = [
  { key: "register", label: "Register" },
  { key: "consent", label: "Consent" },
  { key: "voice", label: "Voice" },
  { key: "questionnaires", label: "Questionnaires" },
  { key: "results", label: "Results" },
];
